/**
 * Settings card wrapper.
 *
 * Extracted from AdminSettingsPage.tsx (Sub-PR 6.3).
 */

interface SettingCardProps {
  title: string
  description: string
  children: React.ReactNode
}

export function SettingCard({
  title,
  description,
  children,
}: SettingCardProps): React.ReactElement {
  return (
    <div className="rounded-lg border border-stone-200 bg-white p-6 dark:border-stone-700 dark:bg-stone-800">
      <div className="mb-4">
        <h3 className="text-lg font-medium text-stone-900 dark:text-stone-100">{title}</h3>
        <p className="mt-1 text-sm text-stone-500 dark:text-stone-400">{description}</p>
      </div>
      {children}
    </div>
  )
}
